import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IEcommerceView} from "../ecommerce-product.interface";
import {Website} from "../../website";

@Component({
    selector: 'db-ecommerce-item-view',
    templateUrl: './ecommerce-item-view.component.html',
    styleUrls: ['./ecommerce-item-view.component.scss'],
    standalone: false
})
export class EcommerceItemViewComponent implements OnInit {
  @Input() loading;
  @Input() showSidebar = true;
  @Input() showStats = true;
  @Input() pageData: IEcommerceView;
  @Input() headerGreedStyle: {[p: string]: string};
  @Input() headerGreedStyleRefund: {[p: string]: string};
  @Input() tableHeads: string[];
  @Input() website: Website;
  @Input() orderId: number;
  @Input() orderHasRefunds: boolean;
  @Input() fullRefunded?: boolean;
  @Input() orderHasTestPayment: boolean = false;

  showRefund: boolean = false;
  @Output() showRefundSection = new EventEmitter<[boolean, boolean]>();
  constructor() {
  }

  ngOnInit() {
  }

  handleRefundSectionToggle([show, fullRefund]) {
    this.showRefund = show;
    this.showRefundSection.emit([show, fullRefund]);
  }

}
